import React from 'react';
import NoticeList from './NoticeList';
import { useMaintenance } from './useMaintenance';

/**
 * The one site-wide strip, placed once in the layout. Shows only whole-product
 * notices (active banners and upcoming); a whole-product block is shown by
 * every page's own gate, so it is deliberately not repeated here.
 */
const SiteWideNotices: React.FC = () => {
  const { banners, upcoming } = useMaintenance();
  return <NoticeList notices={[...banners, ...upcoming]} />;
};

export default SiteWideNotices;
